import config from './config';

/** The recommendation context enum. */
export enum RecommendationContext {
  HomePage = 'r-homePage',
  PDP = 'r-pdp',
  PDPSale = 'r-pdp-sale',
  Cart = 'r-cart',
  Account = 'r-account',
  NotFoundPage = 'r-not-found-page',
  AddToCart = 'r-add-to-cart',
  Quickview = 'r-quickview',
  PairsWith = 'r-pairs-with',
  Storybook = 'r-storybook',
  PLPTrending = 'r-plp-trending',
  PLPFranchise = 'r-plp-franchise',
  PLPRecentlyViewed = 'r-plp-recently-viewed',
  Search = 'r-search',
  NoSearch = 'r-no-search',
  MiniCart = 'r-minicart',
  TheBureauOfAdventureAthletes = 'r-tba-athletes'
}

/**
 * Enum used to store possible locations for the Recommendations Carousel Placement on a PDP.
 */
export enum ProductDispĺayPageRecommendationsPlacement {
  BeforeReviews,
  BelowReviews
}

const recommendations = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      homepage: {
        context: RecommendationContext.HomePage,
        enabled: false,
        /**
         * By default, mobile recommendations will be slide,
         * and if set to false it will be a grid. Default limit
         * on recommendation tiles to show is 4.
         */
        isSlideOnMobile: false
      },
      pdp: {
        context: RecommendationContext.PDP,
        enabled: false,
        isSlideOnMobile: true,
        slider: {
          slidesPerView: 4,
          mobileSlidesPerView: 1.25,
          navigation: { enabled: true },
          pagination: { enabled: false }
        },
        placement: ProductDispĺayPageRecommendationsPlacement.BelowReviews
      },
      pdpSale: {
        context: RecommendationContext.PDPSale,
        enabled: false,
        isSlideOnMobile: true,
        slider: {
          slidesPerView: 4,
          mobileSlidesPerView: 1.25,
          navigation: { enabled: true },
          pagination: { enabled: false }
        }
      },
      notFoundPage: {
        context: RecommendationContext.NotFoundPage,
        enabled: false,
        isSlideOnMobile: false
      },
      cart: {
        context: RecommendationContext.Cart,
        enabled: false,
        isSlideOnMobile: false
      },
      account: {
        context: RecommendationContext.Account,
        enabled: false,
        isSlideOnMobile: false
      },
      addToCart: {
        context: RecommendationContext.AddToCart,
        enabled: false,
        isSlideOnMobile: false
      },
      quickview: {
        context: RecommendationContext.Quickview,
        enabled: false,
        isSlideOnMobile: false
      },
      pairsWith: {
        context: RecommendationContext.PairsWith,
        enabled: false,
        isSlideOnMobile: false
      },
      storybook: {
        context: RecommendationContext.Storybook,
        enabled: true,
        isSlideOnMobile: true
      },
      plpTrending: {
        context: RecommendationContext.PDP,
        enabled: true,
        isSlideOnMobile: false
      },
      plpFranchise: {
        context: RecommendationContext.PLPFranchise,
        enabled: true,
        isSlideOnMobile: false
      },
      plpRecentlyViewed: {
        context: RecommendationContext.PDP,
        enabled: true,
        isSlideOnMobile: false
      },
      search: {
        context: RecommendationContext.Search,
        enabled: true,
        isSlideOnMobile: true
      },
      noSearch: {
        context: RecommendationContext.NoSearch,
        enabled: true,
        isSlideOnMobile: true
      },
      miniCart: {
        context: RecommendationContext.MiniCart,
        enabled: false,
        isSlideOnMobile: false
      },
      theBureauOfAdventureAthletes: {
        context: RecommendationContext.TheBureauOfAdventureAthletes,
        enabled: false,
        isSlideOnMobile: true
      }
    }
  },
  'SANUK-US': {
    default: {
      homepage: {
        context: RecommendationContext.HomePage,
        enabled: false,
        isSlideOnMobile: false
      },
      pdp: {
        context: RecommendationContext.PDP,
        enabled: true,
        isSlideOnMobile: true
      },
      notFoundPage: {
        context: RecommendationContext.NotFoundPage,
        enabled: true,
        isSlideOnMobile: false
      },
      cart: {
        context: RecommendationContext.Cart,
        enabled: true,
        isSlideOnMobile: false
      },
      pdpSale: {
        context: RecommendationContext.PDPSale,
        enabled: true,
        isSlideOnMobile: true
      },
      plpFranchise: {
        context: RecommendationContext.PLPFranchise,
        enabled: true,
        isSlideOnMobile: false
      },
      account: {
        context: RecommendationContext.Account,
        enabled: false,
        isSlideOnMobile: false
      },
      addToCart: {
        context: RecommendationContext.AddToCart,
        enabled: true,
        isSlideOnMobile: false
      },
      quickview: {
        context: RecommendationContext.Quickview,
        enabled: true,
        isSlideOnMobile: false
      }
    }
  },
  'TEVA-US': {
    default: {
      homepage: {
        context: RecommendationContext.HomePage,
        enabled: true,
        isSlideOnMobile: true
      },
      pdp: {
        context: RecommendationContext.PDP,
        enabled: true,
        isSlideOnMobile: true,
        placement: ProductDispĺayPageRecommendationsPlacement.BeforeReviews,
        slider: { navigation: { enabled: true }, pagination: { enabled: true } }
      },
      notFoundPage: {
        context: RecommendationContext.NotFoundPage,
        enabled: true,
        isSlideOnMobile: true
      },
      cart: {
        context: RecommendationContext.Cart,
        enabled: true,
        isSlideOnMobile: true,
        slider: { navigation: { enabled: true }, pagination: { enabled: true } }
      },
      pdpSale: {
        context: RecommendationContext.PDPSale,
        enabled: true,
        isSlideOnMobile: true,
        slider: { navigation: { enabled: true }, pagination: { enabled: true } }
      },
      account: {
        context: RecommendationContext.Account,
        enabled: true,
        isSlideOnMobile: true
      },
      addToCart: {
        context: RecommendationContext.AddToCart,
        enabled: true,
        isSlideOnMobile: true
      },
      quickview: {
        context: RecommendationContext.Quickview,
        enabled: false,
        isSlideOnMobile: false
      },
      pairsWith: {
        context: RecommendationContext.PairsWith,
        enabled: true,
        isSlideOnMobile: false
      },
      plpTrending: {
        context: RecommendationContext.PLPTrending,
        enabled: true,
        isSlideOnMobile: true
      },
      plpFranchise: {
        context: RecommendationContext.PLPFranchise,
        enabled: true,
        isSlideOnMobile: false
      },
      plpRecentlyViewed: {
        context: RecommendationContext.PLPRecentlyViewed,
        enabled: true,
        isSlideOnMobile: true
      },
      search: {
        context: RecommendationContext.Search,
        enabled: true,
        isSlideOnMobile: true
      },
      noSearch: {
        context: RecommendationContext.NoSearch,
        enabled: true,
        isSlideOnMobile: true
      },
      miniCart: {
        context: RecommendationContext.MiniCart,
        enabled: true,
        isSlideOnMobile: true
      },
      theBureauOfAdventureAthletes: {
        context: RecommendationContext.TheBureauOfAdventureAthletes,
        enabled: true,
        isSlideOnMobile: true
      }
    }
  },
  'AHNU-US': {
    default: {
      homepage: {
        context: RecommendationContext.HomePage,
        enabled: false,
        isSlideOnMobile: false
      },
      pdp: {
        context: RecommendationContext.PDP,
        enabled: true,
        isSlideOnMobile: true,
        slider: { slidesPerView: 3, mobileSlidesPerView: 2 },
        placement: ProductDispĺayPageRecommendationsPlacement.BelowReviews
      },
      notFoundPage: {
        context: RecommendationContext.NotFoundPage,
        enabled: false,
        isSlideOnMobile: false
      },
      cart: {
        context: RecommendationContext.Cart,
        enabled: false,
        isSlideOnMobile: false
      },
      plpFranchise: {
        context: RecommendationContext.PLPFranchise,
        enabled: true,
        isSlideOnMobile: false
      },
      pdpSale: {
        context: RecommendationContext.PDPSale,
        enabled: true,
        isSlideOnMobile: true,
        slider: { slidesPerView: 3, mobileSlidesPerView: 2 }
      },
      account: {
        context: RecommendationContext.Account,
        enabled: false,
        isSlideOnMobile: false
      },
      addToCart: {
        context: RecommendationContext.AddToCart,
        enabled: false,
        isSlideOnMobile: false
      },
      quickview: {
        context: RecommendationContext.Quickview,
        enabled: false,
        isSlideOnMobile: true
      },
      pairsWith: {
        context: RecommendationContext.PairsWith,
        enabled: false,
        isSlideOnMobile: false
      }
    },
    'HOKA-US': {
      default: {
        homepage: {
          context: RecommendationContext.HomePage,
          enabled: true,
          isSlideOnMobile: true
        },
        pdp: {
          context: RecommendationContext.PDP,
          enabled: true,
          isSlideOnMobile: true,
          placement: ProductDispĺayPageRecommendationsPlacement.BeforeReviews,
          slider: {
            navigation: { enabled: true },
            pagination: { enabled: true }
          }
        },
        notFoundPage: {
          context: RecommendationContext.NotFoundPage,
          enabled: true,
          isSlideOnMobile: true
        },
        cart: {
          context: RecommendationContext.Cart,
          enabled: true,
          isSlideOnMobile: false
        },
        pdpSale: {
          context: RecommendationContext.PDPSale,
          enabled: true,
          isSlideOnMobile: true,
          slider: {
            navigation: { enabled: true },
            pagination: { enabled: true }
          }
        },
        account: {
          context: RecommendationContext.Account,
          enabled: { default: true, prod: false },
          isSlideOnMobile: false
        },
        addToCart: {
          context: RecommendationContext.AddToCart,
          enabled: false,
          isSlideOnMobile: false
        },
        quickview: {
          context: RecommendationContext.Quickview,
          enabled: false,
          isSlideOnMobile: false
        },
        pairsWith: {
          context: RecommendationContext.PairsWith,
          enabled: true,
          isSlideOnMobile: false
        },
        plpTrending: {
          context: RecommendationContext.PLPTrending,
          enabled: true,
          isSlideOnMobile: true
        },
        plpFranchise: {
          context: RecommendationContext.PLPFranchise,
          enabled: true,
          isSlideOnMobile: false
        },
        plpRecentlyViewed: {
          context: RecommendationContext.PLPRecentlyViewed,
          enabled: true,
          isSlideOnMobile: true
        }
      }
    },
    'UGG-US': {
      default: {
        homepage: {
          context: RecommendationContext.HomePage,
          enabled: true,
          isSlideOnMobile: true
        },
        pdp: {
          context: RecommendationContext.PDP,
          enabled: true,
          isSlideOnMobile: true,
          placement: ProductDispĺayPageRecommendationsPlacement.BeforeReviews,
          slider: {
            navigation: { enabled: true },
            pagination: { enabled: true }
          }
        },
        notFoundPage: {
          context: RecommendationContext.NotFoundPage,
          enabled: true,
          isSlideOnMobile: true
        },
        cart: {
          context: RecommendationContext.Cart,
          enabled: true,
          isSlideOnMobile: false
        },
        pdpSale: {
          context: RecommendationContext.PDPSale,
          enabled: true,
          isSlideOnMobile: true,
          slider: {
            navigation: { enabled: true },
            pagination: { enabled: true }
          }
        },
        account: {
          context: RecommendationContext.Account,
          enabled: { default: true, prod: false },
          isSlideOnMobile: false
        },
        addToCart: {
          context: RecommendationContext.AddToCart,
          enabled: false,
          isSlideOnMobile: false
        },
        quickview: {
          context: RecommendationContext.Quickview,
          enabled: false,
          isSlideOnMobile: false
        },
        pairsWith: {
          context: RecommendationContext.PairsWith,
          enabled: true,
          isSlideOnMobile: false
        },
        plpTrending: {
          context: RecommendationContext.PLPTrending,
          enabled: true,
          isSlideOnMobile: true
        },
        plpFranchise: {
          context: RecommendationContext.PLPFranchise,
          enabled: true,
          isSlideOnMobile: false
        },
        plpRecentlyViewed: {
          context: RecommendationContext.PLPRecentlyViewed,
          enabled: true,
          isSlideOnMobile: true
        }
      }
    }
  }
});

export default recommendations;
